<script>
import { computed, defineComponent } from '@vue/composition-api';
import { format } from 'date-fns';
import ptbr from 'date-fns/locale/pt';
import { useManagerDashboard } from '../../composables/useManagerDashboard';

export default defineComponent({
  props: {
    selected: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Number,
      default: () => 0,
    },
    date: {
      type: Date,
      default: () => new Date(),
    },
    height: {
      type: Number,
      default: () => 50,
    },
  },
  setup(props, { listeners }) {
    const { formatNumber } = useManagerDashboard();
    const tooltipVisible = computed(() => props.selected);
    const capitalizeWord = ([first, ...rest]) => first.toUpperCase() + rest.join('');
    const formatDate = (date) => capitalizeWord(format(date, 'MMM', {
      locale: ptbr,
    }));
    return {
      listeners,
      tooltipVisible,
      formatDate,
      formatNumber,
    };
  },
});
</script>

<template>
  <div class="container">
    <div
      class="container__bar"
      :style="{
        height: height * 2 + 'px',
        opacity: selected ? 1 : 0.5
      }"
      v-on="listeners"
    >
      <div
        class="container__bar__tooltip"
        :style="{
          visibility: selected ? 'visible' : 'hidden',
          opacity: selected ? 1 : 0
        }"
      >
        &nbsp;
        <span
          :style="{
            visibility: selected ? 'visible' : 'hidden',
            opacity: selected ? 1 : 0
          }"
          class="container__bar__tooltip__text"
        >R$ {{ formatNumber(value) }}</span>
      </div>
    </div>
    <div class="container__label">
      {{ formatDate(date) }}
    </div>
  </div>
</template>
<style lang="scss" scoped>
.container {
  /* border: 1px solid red; */
  bottom: 2px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  max-width: 45px;
  height: 300px;
  &__bar {
    margin: 12px;
    width: 30px;
    /* max-width: 40px;  */
    height: 150px;
    padding: 10px 0px;
    align-self: center;
    background-color: #0C4439;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    &__tooltip {
      /* border: 1px solid red; */
      position: relative;
      display: block;
      margin-top: -10px;
      width: 100%;
      height: 50px;
    }

    &__tooltip &__tooltip__text {
      /* border: 1px solid red; */
      visibility: hidden;
      width: 90px;
      background-color: #0C4439;
      color: #fff;
      text-align: center;
      padding: 6px 0px;
      border-radius: 6px;
      font-family: 'Nunito Sans';
      font-style: normal;
      font-weight: bold;
      font-size: 10px;
      line-height: 16px;

      /* Position the tooltip text */
      position: absolute;
      z-index: 1;
      bottom: 125%;
      margin-left: -35px;

      /* Fade in tooltip */
      opacity: 0;
      transition: opacity 0.3s;
    }

    &__tooltip &__tooltip__text::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: #0C4439 transparent transparent transparent;
    }

    &__tooltip:hover &__tooltip__text {
      visibility: visible;
      opacity: 1;
    }
  }
  &__label {
    width: 100%;
    /* max-width: 45px; */
    padding: 1px 0px;
    text-align: center;
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
  }
}
</style>
